import * as ACTIONS from "../actions";

const INITIAL_STATE = {
  authUser: null,
  error: ""
};

const applySetAuthUser = (state, action) => ({
  ...state,
  authUser: action.authUser
});

function sessionReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    //Generic Updates
    case ACTIONS.UPDATE_SESSION_ASPECT: {
      return { ...state, [`${action.aspect}`]: action.payload };
    }

    case ACTIONS.UPDATE_SESSION_REDUCER: {
      return { ...state, ...action.payload };
    }

    //Specific Updates
    case ACTIONS.AUTH_USER_SET: {
      return applySetAuthUser(state, action);
    }

    default:
      return state;
  }
}

export default sessionReducer;
